import React, { useEffect} from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import styled from "@emotion/styled";
import {
  AppBar,
  Avatar,
  Box,
  IconButton,
  Toolbar,
  Tooltip,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import PersonIcon from "@mui/icons-material/Person";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import Logout from "@mui/icons-material/Logout";
import { logout } from "../../utils";
import { enqueueSnackbar } from "notistack";

const PageNavbarRoot = styled(AppBar)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  boxShadow: theme.shadows[3],
}));

export const PageNavbar = (props) => {
  const navigate = useNavigate();
  const { onSidebarOpen, onSidebarPersistentOpen, openPersistent, ...other } =
    props;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <PageNavbarRoot
        sx={
          openPersistent
            ? {
                left: {
                  lg: 280,
                },
                width: {
                  lg: "calc(100% - 280px)",
                },
              }
            : {
                left: {
                  lg: 65,
                },
                width: {
                  lg: "calc(100% - 65px)",
                },
              }
        }
        {...other}
      >
        <Toolbar
          disableGutters
          sx={{
            minHeight: 64,
            left: 0,
            px: 2,
          }}
        >
          <IconButton
            onClick={onSidebarOpen}
            sx={{
              display: {
                xs: "inline-flex",
                lg: "none",
              },
            }}
          >
            <MenuIcon fontSize="small" />
          </IconButton>
          <IconButton
            onClick={onSidebarPersistentOpen}
            sx={{
              display: {
                xs: "none",
                lg: "inline-flex",
              },
              backgroundColor: "rgba(255,255,255, 0.08)",
              color: "secondary.dark",
              "&:hover": {
                backgroundColor: "rgba(0,0,0, 0.08)",
              },
            }}
          >
            <MenuIcon fontSize="small" />
          </IconButton>
          <Box sx={{ flexGrow: 1 }} />
          <Tooltip title="Configuración">
            <IconButton
              onClick={handleClick}
              size="small"
              sx={{ ml: 2 }}
              aria-controls={open ? "account-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
            >
              <Avatar
                sx={{
                  height: 40,
                  width: 40,
                  ml: 1,
                  bgcolor: "#1E3C50",
                }}
              >
                <PersonIcon fontSize="medium" color="white" />
              </Avatar>
            </IconButton>
          </Tooltip>
          <Menu
            anchorEl={anchorEl}
            id="account-menu"
            open={open}
            onClose={handleClose}
            onClick={handleClose}
            PaperProps={{
              elevation: 0,
              sx: {
                overflow: "visible",
                filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                mt: 1.5,
                "& .MuiAvatar-root": {
                  width: 32,
                  height: 32,
                  ml: -0.5,
                  mr: 1,
                },
                "&:before": {
                  content: '""',
                  display: "block",
                  position: "absolute",
                  top: 0,
                  right: 14,
                  width: 10,
                  height: 10,
                  bgcolor: "background.paper",
                  transform: "translateY(-50%) rotate(45deg)",
                  zIndex: 0,
                },
              },
            }}
            transformOrigin={{ horizontal: "right", vertical: "top" }}
            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          >
            <MenuItem
              onClick={() => {
                logout();
                navigate("/backoffice");
                enqueueSnackbar("Has cerrado sesión correctamente", {
                  variant: "success",
                });
              }}
            >
              <ListItemIcon>
                <Logout fontSize="small" />
              </ListItemIcon>
              Cerrar sesión
            </MenuItem>
          </Menu>
        </Toolbar>
      </PageNavbarRoot>
    </>
  );
};

PageNavbar.propTypes = {
  onSidebarOpen: PropTypes.func,
};
